import '../App.css';

function About() {
  return (
    <div className="App">
      <div class="topnav">
        <a href="/home">Home</a>
        <a href="/rent">Rent</a>
        <a href="/contact">Contact</a>
        <a class="active" href="/about">About</a>
      </div>
      <h1>About</h1>
      <div class="container-fluid text-center">
        <div class="row content">
          <div class="col-sm-2 sidenav">
          </div>
          <div class="col-sm-8 text-left">
            <h3>Details</h3>
            <p>We are a small rental agency located in Mountain House, California. We currently have five cars in our fleet, which can be rented through Turo. If you have any questions regarding our fleet, feel free to send us an email.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
